import { render, staticRenderFns } from "./ObservatoryControlLayer.vue?vue&type=template&id=a9588bfa&scoped=true&"
import script from "./ObservatoryControlLayer.vue?vue&type=script&lang=js&"
export * from "./ObservatoryControlLayer.vue?vue&type=script&lang=js&"
import style0 from "./ObservatoryControlLayer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ObservatoryControlLayer.vue?vue&type=style&index=1&id=a9588bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9588bfa",
  null
  
)

export default component.exports